import { FilterChip } from '@cibo/ui'
import { useTranslation } from 'react-i18next'

type AcresChipsProps = {
  filters: any & { acresLt?: number; acresGt?: number[] }
  handleUpdate: (newFilters: any & { acresLt?: number; acresGt?: number[] }) => void
}

export const AcresLtChip = ({
  filters: { acresLt, acresGt, ...otherFilters },
  handleUpdate,
}: AcresChipsProps) => {
  const { t } = useTranslation('@cibo/ui/FilterChips')
  return !!acresLt ? (
    <FilterChip
      onDelete={() => handleUpdate(otherFilters)}
      label={!!acresGt ? t('acresRange', { acresGt, acresLt }) : t('acresLessThan', { acresLt })}
    />
  ) : null
}
export const AcresGtChip = ({
  filters: { acresLt, acresGt, ...otherFilters },
  handleUpdate,
}: AcresChipsProps) => {
  const { t } = useTranslation('@cibo/ui/FilterChips')
  return !acresLt && acresGt ? (
    <FilterChip
      onDelete={() => handleUpdate(otherFilters)}
      label={t('acresGreaterThan', { acresGt })}
    />
  ) : null
}
